import type { UUIDv4 } from '@global-types/uuid';
import type { Media } from '@models/groups/app';
import { defineStore, storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useAppDataStore } from './useAppDataStore';

export const useAuthStore = defineStore('auth', () => {
  const appDataStore = useAppDataStore();

  const {
    user,
    isImpersonated,
    organizationUsers,
    impersonatedPipedriveUser,
  } = storeToRefs(appDataStore);

  const isLoggedIn = computed<boolean>(() => !!user.value);

  const setProfilePictureUuid = (uuid: UUIDv4 | null): void => {
    if (!user.value) {
      throw new Error('User not logged in.');
    }
    user.value.profile_picture = uuid ? {
      uuid,
      description: user.value.profile_picture?.description ?? '',
    } as Media : null;
  };

  const profilePictureUuid = computed<UUIDv4 | null>({
    get: (): UUIDv4 | null => user.value?.profile_picture?.uuid ?? null,
    set: (uuid: UUIDv4 | null): void => setProfilePictureUuid(uuid),
  });

  return {
    user,
    organizationUsers,
    isImpersonated,
    isLoggedIn,
    impersonatedPipedriveUser,
    profilePictureUuid,
  };
});
